import { SET_EDIT_FORM_MODAL } from '../actions/modals';

const defaultState = {
  showEditFormModal: false,
  formId: null,
};

const modalsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_EDIT_FORM_MODAL:
      return {
        ...state,
        showEditFormModal: action.payload.showModal,
        formId: action.payload.formId,
      };
    default:
      return state;
  }
};

export default modalsReducer;
